import { EditOutlined } from "@ant-design/icons";
import {
    Avatar,
    Button,
    Checkbox,
    Form,
    Modal,
    Table,
    Tag,
    Tooltip,
    Typography,
} from "antd";
import React, { useContext, useState } from "react";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import { context } from "../../context/context";
import { useNavigate } from "react-router";

const LinkCommentsTable = ({ comments, loading }) => {
    const [form] = Form.useForm();
    // state
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCommentId, setSelectedCommentId] = useState();
    const [commentText, setCommentText] = useState();
    const [commentShow, setCommentShow] = useState();
    const [commentMedia, setCommentMedia] = useState([]);
    // context
    const { setForceUpdate } = useContext(context);
    // columns
    const columns = [
        {
            title: "پروفایل کاربر",
            dataIndex: "userId",
            width: "10%",
            render: (_, { userId }) => (
                <Avatar
                    style={{
                        width: "40px",
                        height: "40px",
                    }}
                    src={
                        <img src={`${userId?.coverPic.address}`} alt="cover" />
                    }
                />
            ),
        },
        {
            title: "نام کاربر",
            dataIndex: "userId",
            width: "10%",
            render: (_, { userId }) => (
                <Typography.Paragraph>{userId?.name}</Typography.Paragraph>
            ),
        },
        {
            title: "محتوای کامنت",
            dataIndex: "address",
            width: "30%",
            render: (_, { text }) => (
                <Tooltip title={text}>
                    <Typography.Paragraph style={{ cursor: "pointer" }}>
                        {text.slice(0, 35)}
                        {text?.length > 35 ? "..." : null}
                    </Typography.Paragraph>
                </Tooltip>
            ),
        },
        {
            title: "قابل رویت",
            dataIndex: "show",
            width: "10%",
            render: (_, { show }) => (
                <>
                    {show ? (
                        <i
                            className={`fa fa-check`}
                            style={{ fontSize: "30px", color: "green" }}
                        />
                    ) : (
                        <i
                            className={`fa fa-times`}
                            style={{ fontSize: "30px", color: "red" }}
                        />
                    )}
                </>
            ),
        },
        {
            title: "امتیاز",
            width: "10%",
            dataIndex: "point",
            render: (_, { point }) => (
                <>
                    <Typography.Paragraph
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                        }}
                    >
                        <i
                            className={`fa fa-star`}
                            style={{ fontSize: "20px", color: "yellow" }}
                        />
                        {point}
                    </Typography.Paragraph>
                </>
            ),
        },
        {
            title: "فایل ها",
            width: "10%",
            dataIndex: "point",
            render: (_, { media }) => (
                <>
                    {media?.map((m) => {
                        return (
                            <Avatar
                                shape="square"
                                style={{
                                    margin: "0 3px",
                                    width: "40px",
                                    height: "40px",
                                }}
                                src={<img src={`${m.address}`} alt="media" />}
                            />
                        );
                    })}
                </>
            ),
        },
        {
            title: "",
            dataIndex: "button",
            key: "button",
            width: "10%",
            render: (text, record) => (
                <>
                    <Tooltip title="ویرایش">
                        <Button
                            onClick={() => showModal(record._id)}
                            type="primary"
                            icon={<EditOutlined />}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        />
                    </Tooltip>
                </>
            ),
        },
    ];
    // functions
    const showModal = (id) => {
        const comment = comments.find((comment) => comment._id === id);
        setSelectedCommentId(id);
        setCommentText(comment?.text);
        setCommentShow(comment?.show);
        setCommentMedia(comment?.media);
        setIsModalOpen(true);
    };
    const navigate = useNavigate();

    const handleOk = () => {
        http.post(
            `${config.parkopoloApi}/api/Detail/comments/${selectedCommentId}`,
            {
                show: commentShow,
                text: commentText,
                media: commentMedia,
            }
        )
            .then(() => {
                setForceUpdate(11);
            })
            .catch((err) => {
                console.log(err);
                setForceUpdate(12);
            });
        navigate("/linkestan", { replace: true });
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const handleTextChange = (e) => {
        setCommentText(e.target.value);
    };
    const onChangeShow = (e) => {
        setCommentShow(e.target.checked);
    };
    const handleDeleteMedia = (id) => {
        const newMedia = commentMedia.filter((media) => media._id !== id);
        setCommentMedia(newMedia);
    };
    return (
        <>
            <Table
                style={{ marginTop: "15px" }}
                pagination={{ pageSize: 6 }}
                bordered
                columns={columns}
                dataSource={comments}
                scroll={{ x: true }}
                loading={loading}
            />
            <Modal
                title="ویرایش کامنت"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <Form
                    layout="vertical"
                    form={form}
                    name="control-hooks"
                    style={{
                        width: "100%",
                        margin: "1rem 0",
                    }}
                >
                    <Form.Item
                        name="تکست"
                        label="محتوای کامنت"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            {commentText}
                        </h4>
                        <input
                            className="ant-input css-dev-only-do-not-override-lzp0br css-dev-only-do-not-override-lzp0br"
                            type="text"
                            value={commentText}
                            style={{ width: "100%", padding: "0.5rem" }}
                            onChange={handleTextChange}
                            placeholder="عنوان را وارد کنید"
                        />
                    </Form.Item>
                    <Form.Item>
                        <Checkbox checked={commentShow} onChange={onChangeShow}>
                            قابل رویت
                        </Checkbox>
                    </Form.Item>
                    <Form.Item>
                        {commentMedia.map((media, key) => {
                            return (
                                <Tag
                                    color="green"
                                    closeIcon
                                    key={media._id}
                                    onClose={() => handleDeleteMedia(media._id)}
                                >
                                    <Avatar
                                        shape="square"
                                        style={{
                                            margin: "0 3px",
                                            width: "60px",
                                            height: "60px",
                                        }}
                                        src={
                                            <img
                                                src={`${media.address}`}
                                                alt="media"
                                            />
                                        }
                                    />
                                </Tag>
                            );
                        })}
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default LinkCommentsTable;
